var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-free-container"},[_c('div',{staticClass:"calendar-free-text"},[_vm._v(" "+_vm._s(_vm.dragging ? _vm.$t('routines.create_new') : _vm.$t('common.free'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }